export default class ReadingPacer {
  constructor() {
    this.speed = 0;
    this.position = 0;
    this.lastTime = 0;
    this.animationId = null;
    this.element = null;
    this.isListening = false;
    this.pointerHandler = this.handlePointer.bind(this);
  }

  setSpeed(level) {
    const speeds = [0, 25, 45, 70];
    const speed = speeds[level] || 0;

    if (speed === 0) {
      this.disable();
      return;
    }

    this.speed = speed;
    if (!this.element) {
      this.element = document.createElement('div');
      this.element.className = 'a11y-pacer';
      document.body.appendChild(this.element);
    }

    if (!this.isListening) {
      document.addEventListener('pointerdown', this.pointerHandler, true);
      this.isListening = true;
    }

    if (!this.animationId) this.start();
  }

  handlePointer(event) {
    if (!this.element) return;
    if (event.target.closest('.a11y-sidebar')) return;

    this.position = event.clientY || 0;
    this.lastTime = 0;
    this.element.style.top = `${this.position}px`;
  }

  start() {
    const step = (ts) => {
      if (!this.speed) return;
      if (!this.lastTime) this.lastTime = ts;
      const delta = (ts - this.lastTime) / 1000;
      this.lastTime = ts;

      const max = Math.max(window.innerHeight - 2, 0);
      this.position = (this.position || 0) + this.speed * delta;
      
      if (this.position > max) this.position = 0;
      if (this.element) this.element.style.top = `${this.position}px`;

      this.animationId = requestAnimationFrame(step);
    };
    this.animationId = requestAnimationFrame(step);
  }

  disable() {
    if (this.isListening) {
      document.removeEventListener('pointerdown', this.pointerHandler, true);
      this.isListening = false;
    }
    if (this.animationId) cancelAnimationFrame(this.animationId);
    this.animationId = null;
    this.speed = 0;
    this.position = 0;
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }
}
